import mixpanel from 'mixpanel-browser';

export const initMixpanel = () => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (token && token !== 'REPLACE_WITH_YOUR_TOKEN') {
    mixpanel.init(token, {
      debug: process.env.NODE_ENV === 'development',
      track_pageview: true,
      persistence: 'localStorage',
    });
  }
};

export const trackEvent = (name, props = {}) => {
  if (process.env.REACT_APP_MIXPANEL_TOKEN) {
    mixpanel.track(name, props);
  }
};
